const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Satispay24 = function Satispay24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement(
      "mask",
      {
        id: "mask0_1_119",
        style: {
          maskType: "luminance",
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "55",
        height: "24",
      },
      /*#__PURE__*/ React.createElement("path", {
        d: "M55 0H0V24H55V0Z",
        fill: "white",
      })
    ),
    /*#__PURE__*/ React.createElement(
      "g",
      {
        mask: "url(#mask0_1_119)",
      },
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask1_1_119",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "5",
          width: "56",
          height: "14",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M0 18.0229H55.3327V5.00017H0V18.0229Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask1_1_119)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M16.3235 13.493H16.4203C16.987 13.6135 17.4937 13.698 17.9882 13.698C18.7361 13.698 19.2788 13.517 19.2788 12.8778C19.2788 11.6959 16.3478 12.166 16.3478 10.2122C16.3478 9.15076 17.3367 8.58378 18.5791 8.58378C19.0739 8.58378 19.5683 8.656 20.0265 8.80074V9.69316H19.93C19.4113 9.52475 18.9651 9.45223 18.5671 9.45223C17.9762 9.45223 17.3609 9.58498 17.3609 10.2122C17.3609 11.3336 20.2917 10.8874 20.2917 12.781C20.2917 14.1565 19.1823 14.5664 17.9519 14.5664C17.3487 14.5664 16.7457 14.4819 16.3235 14.3851V13.493Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M30.1577 14.3494C29.8199 14.4702 29.434 14.5664 28.9515 14.5664C28.3603 14.5664 27.4319 14.4337 27.4319 13.0708V9.59697H26.6836V8.7528H27.4319V7.40188L28.288 7.22088H28.3845V8.7528H30.2425V9.59697H28.3845V13.0468C28.3845 13.6617 28.9033 13.7102 29.1442 13.7102C29.3857 13.7102 29.7714 13.6257 30.0732 13.5292L30.1577 14.3494Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.6907 13.493H33.7872C34.3541 13.6135 34.8609 13.698 35.3553 13.698C36.1033 13.698 36.646 13.517 36.646 12.8778C36.646 11.6959 33.7149 12.166 33.7149 10.2122C33.7149 9.15076 34.7039 8.58378 35.9463 8.58378C36.4408 8.58378 36.9355 8.656 37.3937 8.80074V9.69316H37.2972C36.7785 9.52475 36.332 9.45223 35.9343 9.45223C35.3434 9.45223 34.7278 9.58498 34.7278 10.2122C34.7278 11.3336 37.6589 10.8874 37.6589 12.781C37.6589 14.1565 36.5495 14.5664 35.3191 14.5664C34.7158 14.5664 34.1129 14.4819 33.6907 14.3851V13.493Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M39.9017 13.5776C40.276 13.6378 40.6737 13.6984 41.1804 13.6984C42.3623 13.6984 43.1103 12.9504 43.1103 11.4907C43.1103 10.1398 42.6638 9.45264 41.6991 9.45264C41.1319 9.45264 40.5046 9.69357 39.9017 10.2246V13.5776ZM38.9368 8.76489L39.7809 8.58389H39.9017V9.31988C40.4687 8.89765 41.0839 8.58389 41.9161 8.58389C43.1585 8.58389 44.1232 9.46462 44.1232 11.3463C44.1232 13.1916 43.1585 14.5665 41.1441 14.5665C40.6737 14.5665 40.2997 14.5063 39.9017 14.4218V17.2321L39.0575 17.4131H38.9368V8.76489Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M52.1194 14.3373L50.1746 8.75291H51.2839L52.6501 13.1434H52.7343L54.2348 8.75291H55.3325L53.2051 14.6148C52.6984 16.0622 52.0709 16.7619 51.0337 17.4131L50.491 16.7134C51.5405 15.9657 51.8057 15.5434 52.2036 14.5665",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M48.3684 11.7796L46.8125 12.0089C46.4026 12.0691 45.9438 12.2381 45.9438 12.889C45.9438 13.3598 46.2701 13.6855 46.7643 13.6855C47.295 13.6855 47.8982 13.3475 48.3684 13.0101V11.7796ZM49.3334 14.385L48.5494 14.542H48.4167V13.7458H48.3924C47.886 14.1317 47.2707 14.53 46.4386 14.53C45.7029 14.53 44.9309 13.999 44.9309 12.9615C44.9309 11.563 46.1853 11.3697 46.8608 11.2729L48.3684 11.0679V10.6822C48.3684 9.717 47.9102 9.45179 47.078 9.45179C46.7643 9.45179 45.9804 9.54828 45.3412 9.83776L45.2324 8.94534C45.7634 8.74007 46.5956 8.58334 47.259 8.58334C48.4526 8.58334 49.3334 9.0778 49.3334 10.6822V14.385Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M24.6094 13.0101C24.1392 13.3475 23.536 13.6855 23.0053 13.6855C22.5108 13.6855 22.1848 13.3601 22.1848 12.8893C22.1848 12.2381 22.6436 12.0691 23.0535 12.0089L24.6094 11.7796V13.0101ZM25.5743 10.6822C25.5743 9.0778 24.6936 8.58334 23.4997 8.58334C22.8365 8.58334 22.0041 8.74037 21.4733 8.94534L21.5821 9.83776C22.2213 9.54828 23.0053 9.45179 23.319 9.45179C24.1512 9.45179 24.6094 9.7173 24.6094 10.6822V11.0682L23.1018 11.2732C22.4263 11.3697 21.1719 11.563 21.1719 12.9615C21.1719 13.999 21.9438 14.53 22.6795 14.53C23.5117 14.53 24.1269 14.1317 24.6334 13.7458H24.6576V14.542H24.7904L25.5743 14.385V10.6822Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M31.3391 14.542H31.3419L31.3391 14.539V14.542Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M32.1833 8.58364L31.3391 8.76464V13.8857V14.5381L31.3427 14.542H31.4635L32.3041 14.3622V14.0754V8.58364H32.1833Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M32.1833 6.62672L31.3391 6.80772V7.17692V7.8293L31.3427 7.8335H31.4635L32.3041 7.65339V7.36661V6.62672H32.1833Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M39.9017 11.1489C39.9017 11.4156 39.6856 11.6313 39.4192 11.6313C39.1528 11.6313 38.9368 11.4156 38.9368 11.1489C38.9368 10.8825 39.1528 10.6664 39.4192 10.6664C39.6856 10.6664 39.9017 10.8825 39.9017 11.1489Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M10.4045 5.34808C10.5327 5.21983 10.4419 5.00047 10.2603 5.00047H7.23877L8.99574 6.75684L10.4045 5.34808Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M6.18205 9.57026L4.02113 7.40933L2.07657 9.35419L0.0597843 11.371C-0.0199281 11.4504 -0.0199281 11.5795 0.0597843 11.659L2.07657 13.676L4.02113 15.6206L6.18205 13.4597L4.38133 11.659L4.23719 11.5151L4.38133 11.371L6.18205 9.57026Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M8.99557 16.2735L7.24609 18.0229H10.2533C10.4346 18.0229 10.5257 17.8036 10.3974 17.6753L8.99557 16.2735Z",
          fill: "#EF373F",
        }),
        /*#__PURE__*/ React.createElement("path", {
          d: "M12.9575 11.3712L10.9407 9.35438L8.66948 7.08318L6.64611 5.0598C6.60955 5.02324 6.5601 5.00316 6.50856 5.00136C6.50646 5.00136 6.50436 5.00017 6.50197 5.00017H2.75638C2.57508 5.00017 2.48428 5.21952 2.61254 5.34778L4.34793 7.08318L6.50856 9.2441L8.63592 11.3712L8.77976 11.5153L8.63592 11.6591L6.50856 13.7862L4.34793 15.9471L2.61973 17.6753C2.49148 17.8036 2.58228 18.0229 2.76358 18.0229H6.50796H6.50946C6.5634 18.0229 6.61524 18.0014 6.6533 17.9633L8.66948 15.9471L10.9407 13.6762L12.9575 11.6591C13.0372 11.5797 13.0372 11.4509 12.9575 11.3712Z",
          fill: "#EF373F",
        })
      )
    )
  );
};
Satispay24.defaultProps = {
  width: "55",
  height: "24",
  viewBox: "0 0 55 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Satispay24,
};
export function Satispay(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Satispay' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
